import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';

const CHART_ID = 'estimated_driving_fuel_cost';
/** Stable narrative view for admin overrides and authoring rows (not VMT). */
export const FUEL_COST_NARRATIVE_VIEW_ID = 'fuel_cost';

export interface DrivingFuelCostNarrativeInput {
  locationName: string;
  year: number | null;
  monthlyCostPerCapita: number | null;
}

export function buildDrivingFuelCostAuthoredBundle(input: DrivingFuelCostNarrativeInput) {
  const tokens = {
    locationName: input.locationName,
    latestYear: input.year,
    fuelCostValue: input.monthlyCostPerCapita != null ? input.monthlyCostPerCapita.toFixed(0) : null,
    unit: 'USD per resident per month (modeled gasoline driving fuel)',
    trendSentence: '',
    assumptionSentence: '',
  };
  return renderAuthoredNarrativeBundle(CHART_ID, FUEL_COST_NARRATIVE_VIEW_ID, tokens);
}

export function drivingFuelCostOverviewDescription(): string {
  return getAuthoredOverview(
    CHART_ID,
    FUEL_COST_NARRATIVE_VIEW_ID,
    'Modeled driving fuel cost from VMT, fuel economy, and gasoline prices — not total transportation spending.'
  );
}

export function buildDrivingFuelCostKeyInsights(input: DrivingFuelCostNarrativeInput): string {
  const bundle = buildDrivingFuelCostAuthoredBundle(input);
  return bundle.keyInsights || `Driving fuel cost data are not available for ${input.locationName}.`;
}

/** HOLD_SCIENCE only — invalid per-capita cost ÷ household income; not used by public Fuel Cost UI. */
export interface HeldTransportationBurdenResearchInput {
  locationName: string;
  year: number | null;
  burdenPctOfMedianIncome: number | null;
  monthlyCostPerCapita: number | null;
}

export function heldTransportationBurdenResearchNote(_input: HeldTransportationBurdenResearchInput): string {
  return 'HOLD_SCIENCE: transportation burden % requires household-aligned cost numerator and income denominator.';
}
